<div class="color-picker" >
  <p [class.error]="showError()">{{'Color' | translate}}{{required ? '' : ''}}</p>

  <div class="summary-info" [class.error]="showError()" (click)="toggleColors()" >
    <div class="info">
      <p class="style-value">{{color ? '#' : ''}}{{ color }}</p>
    </div>

    <div class="circle" [ngStyle]="{'background':'#' + color}"></div>
  </div>
  @if (showError()) {
    <span class="error">
      {{'Color is required.' | translate}}
    </span>
  }

  @if (show) {
    <div class="opened">
      <div class="colors">
        @for (color of colors; track color) {
          <div (click)="changeColor(color)" class="circle"
          [ngStyle]="{'background': '#' + color}"></div>
        }
      </div>
    </div>
  }
</div>
